<template>
  <div
    class="rf-leftnav-item [&>a.router-link-active]:before:bg-yellow group [&>a.router-link-active]:fill-white-1! [&>a.router-link-active]:stroke-white-1! [&>a.router-link-active_.rf-leftnav-item--label]:text-white-1! cursor-pointer! select-none"
  >
    <v-tooltip location="right" :disabled="props.wideSidebar" nudgeRight="-5">
      <template #activator="{ props: tooltipProps }">
        <component
          :is="props.linkTo ? 'router-link' : props.nativeLinkTo ? 'a' : 'button'"
          :to="props.linkTo"
          :target="props.nativeLinkTo ? '_blank' : undefined"
          class="h-full w-full"
          :class="{
            'before:absolute 2xl:before:w-1.5!': props.wideSidebar,
            [classesConverted]: true,
          }"
          v-bind="{
            ...(props.nativeLinkTo && !props.linkTo && { href: props.nativeLinkTo }),
          }"
          @click="emit('click')"
        >
          <div
            class="flex! w-full items-center justify-center! gap-3"
            :class="{ '2xl:justify-start! 2xl:pl-7': props.wideSidebar }"
            v-bind="tooltipProps"
          >
            <span class="inline-flex h-6 w-6 items-center justify-center">
              <component
                :is="props.icon"
                class="group-hover:fill-white-1! group-hover:stroke-white-1! rf-leftnav-item--icon fill-beige-30! stroke-beige-30! m-auto h-6! w-6!"
              />
            </span>
            <span
              class="text-buttons text-beige-30 group-hover:text-white-1! rf-leftnav-item--label hidden"
              :class="{ '2xl:block': props.wideSidebar }"
            >
              {{ props.label }}
            </span>
          </div>
        </component>
      </template>
      <span>{{ props.label }}</span>
    </v-tooltip>
  </div>
</template>

<script setup>
import { computed } from "vue";

const emit = defineEmits(["click"]);

const props = defineProps({
  wideSidebar: { type: Boolean, default: false },
  linkClasses: { type: [String, Object, Array], default: "" },
  linkTo: { type: [String, Object], default: null },
  nativeLinkTo: { type: String, default: null },
  label: { type: String, default: "Meny entry" },
  icon: { type: [Object, Function], default: null },
  exact: { type: Boolean, default: false },
});

const classesConverted = computed(() => {
  if (typeof props.linkClasses === "string") return props.linkClasses;
  if (Array.isArray(props.linkClasses)) return props.linkClasses.join(" ");
  if (typeof props.linkClasses === "object")
    return Object.keys(props.linkClasses)
      .filter(key => props.linkClasses[key])
      .join(" ");
  return "";
});
</script>

<style lang="scss" scoped>
.rf-leftnav-item {
  > a,
  > button,
  .realtime-link-leftmenu {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: normal;
    > * {
      width: 100%;
      padding: 12px 16px;
      text-align: center;
      display: inline-block;
    }
    &:hover {
      background: #353431;
    }
  }
  > a.router-link-active {
    background: #54534d;
    opacity: 1;
    position: relative;
    &::before {
      width: 6px;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      content: " ";
      z-index: 1;
    }
  }
}
</style>
